import { datadogLogs } from '@datadog/browser-logs';
import debug from 'debug';
/*
  Usage:-
    logs will show in development only, in production logs will be disabled
    to turn on in production set localStorage.debug = 'MG*';

  import { Logger } from '@montu-web/utilities';
  const logger = new Logger('MyComponent');
  ...
  ...
  logger.info(`hello world ${someValue}`);

*/
const NAMESPACE = 'MG';
const ENABLE_DDOG = process.env.NODE_ENV === 'production';
if (!ENABLE_DDOG) {
    debug.enable(`${NAMESPACE}*`);
}
export class Logger {
    _debug;
    _info;
    _warn;
    _error;
    prefix;
    enableDDogBrowserLogs;
    static getUserIdFunc;
    constructor(prefix) {
        if (prefix) {
            this._debug = debug(`${NAMESPACE}:${prefix}`);
            this._info = debug(`${NAMESPACE}:INFO:${prefix}`);
            this._warn = debug(`${NAMESPACE}:WARN:${prefix}`);
            this._error = debug(`${NAMESPACE}:ERROR:${prefix}`);
        }
        else {
            this._debug = debug(`${NAMESPACE}`);
            this._info = debug(`${NAMESPACE}:INFO`);
            this._warn = debug(`${NAMESPACE}:WARN`);
            this._error = debug(`${NAMESPACE}:ERROR`);
        }
        this.enableDDogBrowserLogs = ENABLE_DDOG;
        this.prefix = prefix;
        this._debug.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.debug.apply(console, arguments);
        };
        this._info.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.info.apply(console, arguments);
        };
        this._warn.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.warn.apply(console, arguments);
        };
        this._error.log = function () {
            // @ts-expect-error: TS2345: Argument of type 'IArguments' is not assignable to parameter of type 'string'.
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            console.error.apply(console, arguments);
        };
    }
    debug(...args) {
        this.wrapLog(this._debug, 'debug', ...args);
    }
    info(...args) {
        this.wrapLog(this._info, 'info', ...args);
    }
    warn(...args) {
        this.wrapLog(this._warn, 'warn', ...args);
    }
    error(...args) {
        this.wrapLog(this._error, 'error', ...args);
    }
    static getUserId() {
        if (Logger.getUserIdFunc) {
            return Logger.getUserIdFunc();
        }
        return undefined;
    }
    sendToDatadog(logLevel, ...args) {
        try {
            const first = args?.[0];
            const firstMsg = typeof first === 'string' || first instanceof String ? first : JSON.stringify(first);
            const msg = [NAMESPACE];
            if (this.prefix) {
                msg.push(this.prefix);
            }
            msg.push(firstMsg);
            const messageContext = {
                args,
                user_id: Logger.getUserId() || 'logged_out'
            };
            // find the first error in the args, and send this to ddog as an 'error'
            const err = args.find((x) => x instanceof Error);
            datadogLogs.logger.log(msg.join(':'), messageContext, logLevel, err);
        }
        catch (err) {
            console.error('failed to send to datadog: ', err);
        }
    }
    wrapLog = (logFunc, logLevel, ...args) => {
        logFunc(...args);
        if (this.enableDDogBrowserLogs && logLevel !== 'debug') {
            this.sendToDatadog(logLevel, ...args);
        }
    };
}
//# sourceMappingURL=data:application/json;base64,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